
import letteringQuery from "@/apollo/queries/pages/lettering.gql";
import lenisScrollMixin from '@/mixins/lenisScrollMixin';
import previewModeMixin from '@/mixins/previewModeMixin';

export default {
  name: 'lettering',
  colorMode: 'light',
  mixins: [lenisScrollMixin, previewModeMixin],
  data() {
    return {
      lettering: null,
    };
  },
  async asyncData({app, store}) {
    const previewMode = store.state.previewMode;

    if (previewMode) {
      await app.apolloProvider.defaultClient.resetStore();
    }

    const responseLettering = await app.apolloProvider.defaultClient.query({
      query: letteringQuery,
      variables: {
        locale: app.i18n.locale || 'en',
      },
    }).catch((err) => {
      console.log(JSON.stringify(err, null, 2));
    });

    const lettering = responseLettering.data?.lettering;

    return {
      lettering,
      previewMode,
    };
  },
}
